/* Base B intenso. Sin dependencias; hs-carrito.js puede reemplazar HS.carrito. */
(function () {
  'use strict';
  window.HS = window.HS || {};

  const fetchOriginal = window.fetch;
  window.HS._fetchOriginal = fetchOriginal;

  async function pedir(ruta, datos) {
    let respuesta;
    for (let intento = 0; ; intento++) {
      respuesta = await fetchOriginal.call(window, ruta, {
        method: datos ? 'POST' : 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', ...(datos ? { 'Content-Type': 'application/json' } : {}) },
        ...(datos ? { body: JSON.stringify(datos) } : {}),
        cache: 'no-store'
      });
      if (respuesta.status !== 429 || intento === 3) break;
      await new Promise(resolve => setTimeout(resolve, 3000 * 2 ** intento));
    }
    const resultado = await respuesta.json();
    if (!respuesta.ok) throw new Error(resultado.description || 'No se pudo actualizar el carrito.');
    return resultado;
  }

  function actualizar(cart) {
    document.querySelectorAll('[data-hs-cart-count]').forEach(el => { el.textContent = String(cart.item_count); });
    document.querySelectorAll('[data-hs-cart-total] .hs-precio > .money').forEach(anterior => {
      // Un nodo nuevo permite que el MutationObserver del conversor lo detecte.
      // No conservar data-converted, data-original-price ni data-applied-rate.
      const precio = document.createElement('span');
      precio.className = 'money';
      precio.textContent = '$' + (cart.total_price / 100).toFixed(2);
      anterior.replaceWith(precio);
    });
  }
  document.addEventListener('hs:carrito-actualizado', evento => actualizar(evento.detail.cart));

  async function leerCarrito() {
    const cart = await pedir('/cart.js');
    document.dispatchEvent(new CustomEvent('hs:carrito-actualizado', { detail: { cart } }));
    return cart;
  }

  if (!window.HS.carrito) {
    window.HS.carrito = {
      abrir() { window.location.href = '/cart'; },
      cerrar() {},
      async agregar(variantId, cantidad) {
        await pedir('/cart/add.js', { items: [{ id: variantId, quantity: cantidad }] });
        return leerCarrito();
      },
      async cambiar(key, cantidad) {
        await pedir('/cart/change.js', { id: key, quantity: cantidad });
        return leerCarrito();
      },
      async refrescar() { await leerCarrito(); }
    };
  }

  // El tema usa eventos nativos para add/delete y drawer:Minicart para cambios.
  // Observar también transporte cubre clear.js (jQuery/XHR) y otras páginas viejas.
  // Las peticiones de HS usan fetchOriginal para evitar refrescos duplicados.
  let refrescoPendiente;
  function programarRefresco() {
    clearTimeout(refrescoPendiente);
    refrescoPendiente = setTimeout(() => {
      Promise.resolve().then(() => window.HS.carrito.refrescar()).catch(error => {
        console.warn('HS: no se pudo refrescar el carrito.', error);
      });
    }, 80);
  }
  function esMutacion(ruta) {
    try {
      const destino = new URL(ruta, window.location.href);
      return destino.origin === window.location.origin &&
        /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(destino.pathname);
    } catch (_) { return false; }
  }
  window.fetch = function (...argumentos) {
    const ruta = argumentos[0] instanceof Request ? argumentos[0].url : argumentos[0];
    return fetchOriginal.apply(this, argumentos).then(respuesta => {
      if (respuesta.ok && esMutacion(ruta)) programarRefresco();
      return respuesta;
    });
  };
  const abrirXHR = XMLHttpRequest.prototype.open;
  const enviarXHR = XMLHttpRequest.prototype.send;
  const rutasXHR = new WeakMap();
  XMLHttpRequest.prototype.open = function (metodo, ruta, ...resto) {
    rutasXHR.set(this, ruta);
    return abrirXHR.call(this, metodo, ruta, ...resto);
  };
  XMLHttpRequest.prototype.send = function (...argumentos) {
    this.addEventListener('load', () => {
      if (this.status >= 200 && this.status < 300 && esMutacion(rutasXHR.get(this))) programarRefresco();
    }, { once: true });
    return enviarXHR.apply(this, argumentos);
  };
  ['ajax:addToCart', 'ajax:updateCart', 'ajax:deleteCart', 'drawer:Minicart'].forEach(nombre => {
    document.addEventListener(nombre, programarRefresco);
    document.body.addEventListener(nombre, programarRefresco);
  });

  let activador = null;
  let restaurarFondo = [];
  function panel() { return document.getElementById('hs-panel-categorias'); }

  function cerrar() {
    const elemento = panel();
    if (!elemento || elemento.hidden) return;
    elemento.hidden = true;
    document.querySelectorAll('[data-hs-panel-fondo]').forEach(el => { el.hidden = true; });
    document.querySelectorAll('[data-hs-categorias]').forEach(el => el.setAttribute('aria-expanded', 'false'));
    document.body.classList.remove('hs-panel-abierto');
    restaurarFondo.forEach(([el, previo]) => { el.inert = previo; });
    restaurarFondo = [];
    if (activador && activador.isConnected) activador.focus({ preventScroll: true });
  }

  function abrir(boton) {
    const elemento = panel();
    if (!elemento || !elemento.hidden) return;
    activador = boton;
    elemento.hidden = false;
    document.querySelectorAll('[data-hs-panel-fondo]').forEach(el => { el.hidden = false; });
    document.querySelectorAll('[data-hs-categorias]').forEach(el => el.setAttribute('aria-expanded', 'true'));
    document.body.classList.add('hs-panel-abierto');
    // Aísla el fondo del diálogo para teclado y tecnologías de asistencia.
    let rama = elemento;
    while (rama.parentElement && rama !== document.body) {
      Array.from(rama.parentElement.children).forEach(el => {
        if (el === rama || el.matches('[data-hs-panel-fondo], script, style')) return;
        restaurarFondo.push([el, el.inert]);
        el.inert = true;
      });
      rama = rama.parentElement;
    }
    (elemento.querySelector('a') || elemento).focus();
  }

  document.addEventListener('click', function (evento) {
    if (!(evento.target instanceof Element)) return;
    document.querySelectorAll('.hs-categorias-escritorio[open]').forEach(menu => {
      if (!menu.contains(evento.target)) menu.open = false;
    });
    const boton = evento.target.closest('[data-hs-categorias]');
    if (boton) { evento.preventDefault(); abrir(boton); return; }
    if (evento.target.closest('[data-hs-panel-cerrar], [data-hs-panel-fondo]')) { cerrar(); return; }
    if (evento.target.closest('[data-hs-buscar]')) {
      const buscador = document.getElementById('hs-buscar');
      if (!buscador) return;
      evento.preventDefault();
      window.scrollTo({ top: 0, behavior: 'instant' });
      buscador.focus({ preventScroll: true });
    }
  });

  document.addEventListener('keydown', function (evento) {
    if (evento.key === 'Escape') {
      document.querySelectorAll('.hs-categorias-escritorio[open]').forEach(menu => {
        menu.open = false;
        menu.querySelector('summary').focus();
      });
    }
    const elemento = panel();
    if (!elemento || elemento.hidden) return;
    if (evento.key === 'Escape') { evento.preventDefault(); cerrar(); }
    if (evento.key === 'Tab') {
      const enlaces = Array.from(elemento.querySelectorAll('a[href], button:not([disabled])'));
      const primero = enlaces[0];
      const ultimo = enlaces[enlaces.length - 1];
      if (evento.shiftKey && document.activeElement === primero) { evento.preventDefault(); ultimo.focus(); }
      else if (!evento.shiftKey && document.activeElement === ultimo) { evento.preventDefault(); primero.focus(); }
    }
  });
  window.matchMedia('(min-width: 768px)').addEventListener('change', evento => { if (evento.matches) cerrar(); });
  document.addEventListener('shopify:section:unload', cerrar);
})();

/* R26: contador compartido, también para nodos añadidos por secciones dinámicas. */
(() => {
  'use strict';
  const activos = new Map();
  const iniciados = new WeakSet();
  let temporizador;
  function pintar(elemento, fin) {
    const segundos = Math.max(0, Math.ceil((fin - Date.now()) / 1000));
    if (!segundos) { elemento.textContent = 'Terminó'; elemento.closest('[data-hs-oferta]')?.setAttribute('hidden', ''); activos.delete(elemento); return; }
    const dias = Math.floor(segundos / 86400);
    const horas = Math.floor(segundos % 86400 / 3600);
    const minutos = Math.floor(segundos % 3600 / 60);
    if (elemento.hasAttribute('data-hs-contador-bloques')) {
      if (!elemento.children.length) {
        elemento.textContent = '';
        ['HH', 'MM', 'SS'].forEach(unidad => {
          const bloque = document.createElement('span');
          bloque.dataset.unidad = unidad;
          elemento.append(bloque);
        });
      }
      [Math.floor(segundos / 3600), minutos, segundos % 60].forEach((valor, i) => {
        const bloque = elemento.children[i];
        bloque.textContent = String(valor).padStart(2, '0');
        bloque.setAttribute('aria-label', `${valor} ${['horas', 'minutos', 'segundos'][i]}`);
      });
      return;
    }
    elemento.textContent = `${dias} d ${String(horas).padStart(2, '0')} h ${String(minutos).padStart(2, '0')} min ${String(segundos % 60).padStart(2, '0')} s`;
  }
  function actualizar() {
    activos.forEach((fin, elemento) => {
      if (!elemento.isConnected) activos.delete(elemento);
      else pintar(elemento, fin);
    });
    if (!activos.size) { clearInterval(temporizador); temporizador = null; }
  }
  function iniciar(nodo) {
    if (!(nodo instanceof Element)) return;
    const elementos = [...nodo.querySelectorAll('[data-hs-cuenta-regresiva]')];
    if (nodo.matches('[data-hs-cuenta-regresiva]')) elementos.push(nodo);
    elementos.forEach(elemento => {
      if (iniciados.has(elemento)) return;
      iniciados.add(elemento);
      const fin = Date.parse(elemento.dataset.hsCuentaRegresiva);
      if (!Number.isFinite(fin)) { elemento.closest('[data-hs-oferta]')?.setAttribute('hidden', ''); return; }
      elemento.classList.add('hs-mono');
      activos.set(elemento, fin); pintar(elemento, fin);
    });
    if (activos.size && !temporizador) temporizador = setInterval(actualizar, 1000);
  }
  let observador;
  let limiteDeteccion = Date.now() + 10000;
  function detectar() {
    if (Date.now() >= limiteDeteccion) clearInterval(deteccion);
    if (!document.querySelector('[data-hs-cuenta-regresiva]')) return;
    iniciar(document.documentElement);
    if (observador) return;
    clearInterval(deteccion);
    observador = new MutationObserver(cambios => cambios.forEach(cambio => cambio.addedNodes.forEach(iniciar)));
    observador.observe(document.documentElement, { childList: true, subtree: true });
  }
  // Un chequeo barato permite insertar el primer contador sin observar todo el DOM.
  let deteccion = setInterval(detectar, 1000);
  document.addEventListener('shopify:section:load', () => {
    if (!observador) {
      clearInterval(deteccion);
      limiteDeteccion = Date.now() + 10000;
      deteccion = setInterval(detectar, 1000);
    }
    detectar();
  });
  detectar();
})();

/* Carruseles compartidos: independientes de la ficha de producto. */
(() => {
  'use strict';
  const raiz = window.Shopify?.routes?.root || '/';
  document.addEventListener('click', evento => {
    const boton = evento.target.closest('[data-hs-carrusel-paso]');
    if (!boton) return;
    const pista = boton.closest('.hs-carrusel-productos')?.querySelector('.hs-carrusel-productos__pista');
    pista?.scrollBy({ left: Number(boton.dataset.hsCarruselPaso) * pista.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
  document.querySelectorAll('[data-hs-relacionados]').forEach(async seccion => {
    try {
      const parametros = new URLSearchParams({ product_id: seccion.dataset.producto, limit: '8', section_id: seccion.dataset.seccion });
      const respuesta = await fetch(`${raiz}recommendations/products?${parametros}`);
      if (!respuesta.ok) throw new Error('Recomendaciones no disponibles');
      const html = new DOMParser().parseFromString(await respuesta.text(), 'text/html');
      const tarjetas = html.querySelector('[data-hs-relacionados] .hs-carrusel-productos__pista');
      if (tarjetas?.children.length) { seccion.querySelector('.hs-carrusel-productos__pista').replaceChildren(...tarjetas.children); seccion.hidden = false; document.body.dispatchEvent(new CustomEvent('contentUpdated', { bubbles: true })); }
    } catch (_) { /* Sin recomendaciones, no se muestra la sección. */ }
  });
  document.querySelectorAll('[data-hs-vistos]').forEach(async seccion => {
    const actual = seccion.dataset.handle;
    let anteriores = [];
    try {
      const guardados = JSON.parse(localStorage.getItem('hs-vistos') || '[]');
      if (Array.isArray(guardados)) anteriores = [...new Set(guardados.filter(h => typeof h === 'string' && /^[a-z0-9-]+$/.test(h) && h !== actual))].slice(0, 8);
      localStorage.setItem('hs-vistos', JSON.stringify([actual, ...anteriores].slice(0, 8)));
    } catch (_) { /* El almacenamiento privado no impide usar la ficha. */ }
    const pista = seccion.querySelector('.hs-carrusel-productos__pista');
    // Secuencial para no saturar Shopify; cada respuesta usa el snippet de tarjeta único.
    for (const handle of anteriores.slice(0, 4)) {
      try {
        const url = new URL(`${raiz}products/${encodeURIComponent(handle)}`, location.origin);
        url.searchParams.set('section_id', seccion.dataset.seccion);
        const respuesta = await fetch(url);
        if (respuesta.status === 429) break;
        if (!respuesta.ok) continue;
        const html = new DOMParser().parseFromString(await respuesta.text(), 'text/html');
        const plantilla = html.querySelector('template[data-hs-tarjeta-vista]');
        if (!plantilla?.content.firstElementChild) continue;
        pista.append(plantilla.content.firstElementChild); seccion.hidden = false;
        document.body.dispatchEvent(new CustomEvent('contentUpdated', { bubbles: true }));
      } catch (_) { /* Producto eliminado o no publicado: continuar con los demás. */ }
    }
  });
})();

/* Oculta controles sin desbordamiento, incluso tras Section Rendering. */
(() => {
  const observados = new Map();
  const actualizar = pista => {
    const controles = pista.closest('.hs-carrusel-productos')?.querySelector('.hs-carrusel-productos__controles');
    if (controles) controles.hidden = pista.scrollWidth <= pista.clientWidth + 1;
  };
  const resize = new ResizeObserver(entradas => entradas.forEach(({ target }) => actualizar(target)));
  function detectar() {
    observados.forEach((observador, pista) => {
      if (!pista.isConnected) { resize.unobserve(pista); observador.disconnect(); observados.delete(pista); }
    });
    document.querySelectorAll('.hs-carrusel-productos__pista').forEach(pista => {
      actualizar(pista);
      if (observados.has(pista)) return;
      const observador = new MutationObserver(() => actualizar(pista));
      observados.set(pista, observador); resize.observe(pista);
      observador.observe(pista, { childList: true });
    });
  }
  document.addEventListener('contentUpdated', detectar);
  document.addEventListener('shopify:section:load', detectar);
  detectar();
})();
